import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import accountReducer from './slices/accountSlice';
import paymentReducer from './slices/paymentSlice';
import adminReducer from './slices/adminSlice';
import adminPaymentReducer from './slices/adminPaymentSlice';
import analyticsReducer from './slices/analyticsSlice';
import uiReducer from './slices/uiSlice';
import virtualNumberReducer from './slices/virtualNumberSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    accounts: accountReducer,
    payments: paymentReducer,
    admin: adminReducer,
    adminPayment: adminPaymentReducer,
    analytics: analyticsReducer,
    ui: uiReducer,
    virtualNumbers: virtualNumberReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});